import React from 'react'
import context from '@/context'
import { Label } from 'reactstrap'
import Resx from '@/components/Resx'
import { FileItem } from '@/components/fileAttachments/fileItem'

const Attachments = (props) => {
  const { attachments } = props
  if (!attachments || attachments.length === 0) { return null }
  return <React.Fragment>
    <Label><Resx name='Individuals.PreviousReports' /></Label>
    {attachments.map((file, idx) =>
      <FileItem
        key={idx}
        {...file}
        isRemoveEnabled={false}
        downloadAction={context.api.individualService.download} />)
    }
  </React.Fragment>
}

export {
  Attachments
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/individuals/cbsReports/attachments.js